// extracted by mini-css-extract-plugin
export default {"btnWrapper":"ClientCard_btnWrapper__PpNA1","card":"ClientCard_card__Xelo4","link":"ClientCard_link__9FOYh","notActive":"ClientCard_notActive__91ChU"};